import React from "react";

export default function WeatherDetails(props) {
  var data = props.data;
  return (
    <div className=" mt-5 d-flex  justify-content-evenly">
      <div className="weather-details">
        <span className="fw-lighter " id="humidity">
          Humidity:<span id="humidity-value">{data.humidity}</span>
          <span>%</span>
        </span>
      </div>
      <div className="weather-details">
        <span className="fw-lighter " id="wind">
          Wind:<span id="wind-value">{Math.round(data.wind)}</span>
          <span>km/h</span>
        </span>
      </div>
      <div className="weather-details">
        <span className="text-capitalize fw-lighter" id="description">
          {data.description}
        </span>
      </div>
    </div>
  );
}
